import React from 'react';
import { Button } from '@/components/ui/Buttons';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import I18n from 'i18n-js';

interface ExpandCollapseButtonProps {
  isExpanded: boolean;
  onToggle: () => void;
}

export function ExpandCollapseButton({ isExpanded, onToggle }: ExpandCollapseButtonProps) {
  const label = isExpanded ? I18n.t('collapse_all') : I18n.t('expand_all');

  return (
    <Button className="btn btn--outline-purple" onClick={onToggle}>
      <div className="tw-flex tw-align-middle tw-items-center">
        <Icon icon={isExpanded ? 'CollapseRounded' : 'ExpandRounded'} size={18} />
        <Text className="tw-ml-2" size="sm">{label}</Text>
      </div>
    </Button>
  );
}
